import { FunctionComponent, useEffect, useState } from 'react';
import { useTheme } from '@mui/material/styles';
import { useAtom } from 'jotai';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next'

import { fetch_all, fetch_one } from '../../lib/server_helper';
// import { checkAllowed } from '../../lib/permission';
import { loginAtom } from '../../lib/auth';

import {
  Box,
  Button as Btn,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Snackbar,
  Tooltip
} from '@mui/material';
import MuiAlert from '@mui/material/Alert';
import { GridColDef } from '@mui/x-data-grid-pro';

import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ClearIcon from '@mui/icons-material/Clear';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import ReportIcon from '@mui/icons-material/Report';
import SendIcon from '@mui/icons-material/Send';
import ToggleOffIcon from '@mui/icons-material/ToggleOff';
import ToggleOnIcon from '@mui/icons-material/ToggleOn';

import { AlertSomethingWentWrong } from '../../components/alerts/SomethingWentWrong';

import { getCookie, setCookie } from 'react-use-cookie';

import {
  DataGrid,
  Dt,
  Page,
  SearchBox,
  StyledButton,
  StyledIconButton,
  Typography
} from '../../components/interface';

import { Company } from '../../models/Company';
// import { Project } from '../../models/Project';
import { UserInvite } from '../../models/UserInvite';

const { DateTime } = require("luxon");

type Props = {};

export const AdminUserInvitesCompany: FunctionComponent<Props> = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const {t, i18n} = useTranslation(['translations']);

  const [login, setLogin] = useAtom(loginAtom);
  let [searchParams, setSearchParams] = useSearchParams();

  const [theCompany, setTheCompany] = useState<Company>();
  const [objects, setObjects] = useState<UserInvite[]>([]);
  const [objectsCount, setObjectsCount] = useState<number>(0);
  const [loader, setLoader] = useState<boolean>(true);
  // const [showEdit, setShowEdit] = useState<boolean>(false);
  const [removeLoader, setRemoveLoader] = useState<boolean>(false);
  const [handleLoader, setHandleLoader] = useState<boolean>(false);
  const [open, setOpen] = useState<boolean>(false);
  const [filterOpen, setFilterOpen] = useState<boolean>(false);
  const [warningOpen, setWarningOpen] = useState<boolean>(false);
  const [page, setPage] = useState<number>(0);
  const [order, setOrder] = useState<string>("is_archived ASC, email ASC");
  const [serverErrorSnackOpen, setServerErrorSnackOpen] = useState<boolean>(false);
  const [activeCompany, setActiveCompany] = useState<string>(getCookie('cribeon_active_company_id') || '');

  const [filterId, setFilterId] = useState<string|null>(searchParams.get('filter'));

  // Settings


  useEffect(() => {
    if (!!activeCompany) onSearch('');
  }, [page, order, activeCompany]);
  useEffect(() => {
    if (!!activeCompany) fetchCompany();
  }, [activeCompany]);
  useEffect(() => {
    setFilterId(searchParams.get('filter'));
  }, [searchParams.get('filter')]);

  const fetchCompany = () => {
    fetch_one<Company>('/nl/v3/objects/fetch_all', {
      object: 'company',
      fields: ['id', 'name', 'user_invites_without_answers_count'],
      id: activeCompany
    }, (ob, complete_data) => {
      setTheCompany(ob);
    }, (z) => {
      setServerErrorSnackOpen(true);
    }, (!!login?.auth_token ? {auth_token: login?.auth_token, email: login?.email} : undefined));
  };

  const onRemove = (id: number) => {
    // if (checkAllowed(login, null, projectId?.toString() || '0', "ProjectSegments", 'd', true)) {
      setRemoveLoader(true);
      fetch_one<UserInvite>('/nl/v3/objects/remove', {
        object: 'user_invite',
        ob: {
          id: id
        }
      }, (obs, complete_data) => {
        onSearch('');
        setRemoveLoader(false);
      }, (z) => {

      }, (!!login?.auth_token ? {auth_token: login?.auth_token, email: login?.email} : undefined));
    // }
  };

  const onSearch = (s: string) => {
    // if (checkAllowed(login, null, projectId?.toString() || '0', "ProjectSegments", 'r', true)) {
      // console.log(filters);
      setLoader(true);
      fetch_all<UserInvite>('/nl/v3/objects/fetch_all', {
        object: 'user_invite',
        fields: ['id', 'created_at', 'email', 'phone', 'invited', 'registered', 'user_id', 'has_answers', 'postmark_data', 'project|id/name', 'is_archived', 'email_suppression', 'extra_data'],
        per_page: !!filterOpen ? ((theCompany?.user_invites_without_answers_count || 0) + 1) : 20,
        page: page,
        order: order,
        filter: {
          search: s,
          advanced: {
            company_id: activeCompany,
            skip_answered: !!filterOpen ? 1 : 0,
            fallback: s,
            ...(!!filterId ? {id: filterId} : {})
          }
        }
      }, (obs, complete_data) => {
        setObjects(obs);

        let count:number = 0;
        if (typeof(complete_data?.data) === 'object' && 'count' in complete_data?.data) count = complete_data?.data?.count;
        setObjectsCount(count);

        setLoader(false);
      }, (z) => {
        setServerErrorSnackOpen(true);
      }, (!!login?.auth_token ? {auth_token: login?.auth_token, email: login?.email} : undefined));
    // } else {
    //   setLoader(false);
    // }
  };

  const handleArchive = (id:number) => {
    if (!!login) {
      setHandleLoader(true);
      fetch_one<UserInvite>('/nl/v3/objects/custom_action', {
        object: 'user_invite',
        class_action: 'custom_api_toggle_archive',
        handler_id: login.id,
        id: id
      }, (obs, complete_data) => {
        onSearch('');
      }, (z) => {
        setServerErrorSnackOpen(true);
      }, login);
    }
  };

  const handleSend = () => {
    if (!!login) {
      setHandleLoader(true);
      fetch_one<UserInvite>('/nl/v3/objects/custom_action', {
        object: 'user_invite',
        class_action: 'custom_api_send_invites',
        handler_id: login.id,
        company_id: activeCompany
      }, (obs, complete_data) => {
        onSearch('');
      }, (z) => {
        setServerErrorSnackOpen(true);
      }, login);
    }
  };

  const fancyReason = (ob: any) => {
    return <div>
      Created: {ob.CreatedAt}<br />
      Email: {ob.EmailAddress}<br />
      Reason: {ob.SuppressionReason}<br />
      Origin: {ob.Origin}
    </div>;
  }

  const columns: GridColDef[] = [
    { field: 'id', headerName: 'ID', width: 100, sortable: true },
    { field: 'project_name', headerName: 'Project', width: 160, sortable: true },
    { field: 'email', headerName: 'Email', width: 250, sortable: true, renderCell: params => <>
      {/* @ts-ignore */}
      {params.row.email} {(params.row.postmark_data.suppression_stats?.outbound || []).filter(fff => DateTime.fromISO(fff.CreatedAt) > DateTime.now().minus({year: 1})).length > 0 && <Tooltip title={fancyReason((params.row.postmark_data.suppression_stats?.outbound || []).reverse()[0])}><ReportIcon sx={{color: 'red', marginLeft: 1}} /></Tooltip>}
    </> },
    { field: 'phone', headerName: 'Phone', width: 200, sortable: true },
    // { field: 'invited', headerName: 'Invited', width: 100, sortable: false, renderCell: params => <>
    //   {!params.row.has_answers && params.row.invited && <CheckCircleIcon sx={{color: theme.palette.primary.main}} />}
    //   {!params.row.has_answers && !params.row.invited && <ClearIcon sx={{color: 'red'}} />}
    // </> },
    { field: 'registered', headerName: 'Registered', width: 100, sortable: false, renderCell: params => <>
      {params.row.registered && <CheckCircleIcon sx={{color: theme.palette.primary.main}} />}
      {!params.row.registered && <ClearIcon sx={{color: 'red'}} />}
    </> },
    { field: 'user_id', headerName: 'Exists', width: 100, sortable: false, renderCell: params => <>
      {!!params.row.user_id && <CheckCircleIcon sx={{color: theme.palette.primary.main}} />}
      {!params.row.user_id && <ClearIcon sx={{color: 'red'}} />}
    </> },
    { field: 'has_answers', headerName: 'Answers', width: 100, sortable: false, renderCell: params => <>
      {!!params.row.has_answers && <CheckCircleIcon sx={{color: theme.palette.primary.main}} />}
      {!params.row.has_answers && <ClearIcon sx={{color: 'red'}} />}
    </> },
    { field: 'email_delivered', headerName: 'Last delivery', width: 200, sortable: false, renderCell: params => <>
      {!!params.row?.postmark_data?.last_delivery && <Dt d={params.row.postmark_data.last_delivery} f="d LLLL y - t" />}
    </> },
    { field: 'email_open', headerName: 'Last open', width: 200, sortable: false, renderCell: params => <>
      {!!params.row?.postmark_data?.last_open && <Dt d={params.row.postmark_data.last_open} f="d LLLL y - t" />}
    </> },
  ];



  useEffect(() => {
    if (!!filterOpen) {
      setPage(0);
    }
    setTimeout(() => {
      onSearch('');
    }, 500);
  }, [filterOpen]);



  return (
    <Page sx={{}} title={t("objects.user_invites.title", "Evolutie reacties")} actions={<>
      {/* {checkAllowed(login, null, projectId?.toString() || '0', "ProjectSegments", 'c', true) && <StyledButton
        label="Create new"
        id='create_new'
        contained
        path={`/segment/${projectId}/new`}
        sx={{marginRight: 3}}
        startIcon={<AddCircleOutlineIcon />}
      />} */}
      {!!activeCompany && !filterOpen && !filterId && <StyledButton
        label={`Send${!!theCompany?.user_invites_without_answers_count ? ` ${theCompany.user_invites_without_answers_count}` : ''} invite mails`}
        id='send_invites'
        contained
        onClick={() => {
          setFilterOpen(true);
        }}
        sx={{marginRight: 3}}
        startIcon={<SendIcon />}
      />}
    </>}>
      {!!filterId && <Box sx={{
        marginBottom: 3,
        border: '1px solid transparent',
        borderColor: theme.palette.primary.main,
        borderRadius: 1,
        padding: 2
      }}>
        <Typography sx={{marginBottom: 2}}>Filter active!</Typography>  
        <StyledButton
          label={t("general.btn.back_to_logsources", "Back to Organiser Logs")}
          id='back2logs'
          onClick={() => {
            navigate("/organiser_logs");
          }}
          contained
          sx={{marginRight: 3}}
        />
        <StyledButton
          label={t("general.btn.clear_filter", "Clear filter")}
          id='clear_filter'
          onClick={() => {
            setFilterId(null);
            navigate("/userinvites");
            onSearch('');
          }}
          sx={{marginRight: 3}}
        />
      </Box>}
      {!activeCompany && <Typography>Select a company in the sidebar</Typography>}
      {!!activeCompany && <>
        <SearchBox
          simple={true}
          onSearch={(s) => {
            setPage(0);
            onSearch(s);
          }}
        />
        {!!filterOpen && <Box sx={{
          padding: 2,
          border: '1px solid transparent',
          borderColor: theme.palette.primary.main,
          borderRadius: 1
        }}>
          <Typography html>{t("user_invites.warning_content")}</Typography>
          <StyledButton
            label={t("general.btn.send_emails")}
            id='send_emails'
            onClick={() => {
              setWarningOpen(true);
            }}
            contained
            sx={{marginRight: 3}}
            startIcon={<SendIcon />}
          />
          <StyledButton
            label={t("general.btn.back_to_overview")}
            id='back2overview'
            onClick={() => {
              setFilterOpen(false);
            }}
            sx={{marginRight: 3}}
          />
        </Box>}
        <DataGrid
          action_count={!!filterOpen ? 1 : 2}
          actions={(params) => {
            return (<>
              {!!removeLoader && <CircularProgress />}
              {/* {checkAllowed(login, null, projectId?.toString() || '0', "ProjectSegments", 'd', true) && !removeLoader && <StyledIconButton title="Destroy" destroyBtn color="primary" onClick={(e) => {
                onRemove(params.row.id);
              }}>
                <DeleteForeverIcon />
              </StyledIconButton>} */}
              <StyledIconButton title="Archive" color="primary" onClick={(e) => {
                handleArchive(params.row.id);
              }}>
               {!!params.row.is_archived && <ToggleOffIcon sx={{color: 'grey'}} />}
               {!params.row.is_archived && <ToggleOnIcon />}
              </StyledIconButton>
              {!removeLoader && !filterOpen && <StyledIconButton title="Destroy" destroyBtn color="primary" onClick={(e) => {
                onRemove(params.row.id);
              }}>
                <DeleteForeverIcon />
              </StyledIconButton>}
            </>);
          }}
          getRowClassName={(params) => `datagrid-row-enabled-${!params.row.is_archived}`}
          objectCount={objectsCount}
          objects={(objects || []).map(u => ({
            ...u
          }))}
          columns={columns}
          loader={loader}
          onSortModelChange={(a, b) => {
            let a_0_field:string = a[0].field;
            setOrder([a_0_field, a[0].sort].join(' '));
          }}
          page={!!filterOpen ? 0 : page}
          setPage={(p) => {setPage(p);}}
          hidePagination={!!filterOpen}
          initialState={{
            columns: {
              columnVisibilityModel: {
                phone: !!filterOpen,
              },
            },
          }}
        />

        {!!serverErrorSnackOpen && <AlertSomethingWentWrong open={serverErrorSnackOpen} setOpen={(b) => {setServerErrorSnackOpen(b);}} />}
        {!!open && <Snackbar
        open={open}
          onClose={() => {setOpen(false);}}
          autoHideDuration={2000}
        >
          <MuiAlert elevation={6} variant="filled" severity="success">Imported!</MuiAlert>
        </Snackbar>}

        {!!warningOpen && <Dialog
          open={warningOpen}
          onClose={() => {setWarningOpen(false);}}
        >
          <DialogTitle>{t("general.dialog.send_emails.warning_title", "Emails will be sent")}</DialogTitle>
          <DialogContent>
            <DialogContentText>
              <Typography html>{t("general.dialog.send_emails.warning_body", "Emails will be sent to {{count}} person(s). Are you sure this is what you want?", {count: theCompany?.user_invites_without_answers_count || -1})}</Typography>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Btn onClick={() => {setWarningOpen(false);}}>{t("general.dialog.send_emails.back_cta", "Take me back")}</Btn>
            <Btn onClick={(e) => {
              setWarningOpen(false);
              handleSend();
            }}>{t("general.dialog.send_emails.send_cta", "Send!")}</Btn>
          </DialogActions>
        </Dialog>}
      </>}
    </Page>
  );
}
